if (!customElements.get('localization-drawer-form')) {
  customElements.define(
    'localization-drawer-form',
    class LocalizationDrawerForm extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          input: this.querySelector('input[name="country_code"]'),
          search: this.querySelector('input[name="country_filter"]'),
          resetButton: this.querySelector('.locations-drawer__country-filter-reset-button'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          countryLinks: this.querySelectorAll('a[data-value]'),
        };

        // Bind event listeners
        if (this.elements.search) {
          this.elements.search.addEventListener('input', this.filterCountries.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
        }

        this.elements.countryLinks.forEach((link) => {
          link.addEventListener('click', this.onItemClick.bind(this));
        });
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value.trim());
        let visibleCount = 0;

        this.elements.countryLinks.forEach((link) => {
          const countryName = this.normalizeString(link.dataset.countryName);
          const matches = countryName.includes(searchValue);
          link.parentElement.classList.toggle('hidden', !matches);
          if (matches) visibleCount++;
        });

        // Hide parent accordions if all child countries are hidden
        this.hideEmptyAccordions();

        // Toggle reset button visibility
        this.elements.resetButton.classList.toggle('hidden', !searchValue);

        // Update live region for accessibility
        if (this.elements.liveRegion) {
          this.elements.liveRegion.textContent = `${visibleCount} results found`;
        }
      }

      hideEmptyAccordions() {
        // Find all accordion containers
        const accordions = this.querySelectorAll('.accordion');

        accordions.forEach((accordion) => {
          // Find all country links within this accordion
          const countryLinks = accordion.querySelectorAll('a[data-value]');
          const visibleCountries = Array.from(countryLinks).filter(link =>
            !link.parentElement.classList.contains('hidden')
          );

          // Hide the entire accordion if no countries are visible
          const accordionDetails = accordion.querySelector('details');
          if (accordionDetails && visibleCountries.length > 0) {
            //accordionDetails.open = true;
          }

          if (accordionDetails) {
            accordionDetails.classList.toggle('hidden', visibleCountries.length === 0);
          }
        });
      }

      resetFilter(event) {
        event.preventDefault();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onItemClick(event) {
        if (event.currentTarget.dataset.external === 'false') {
          event.preventDefault();
          const selectedCountry = event.currentTarget.dataset.value;
          const form = this.querySelector('form');
          this.elements.input.value = selectedCountry;
          form.submit();
        }
      }
    },
  );
}
